import { motion } from "framer-motion";
import { ArrowDownRight, ArrowRight } from "lucide-react";
import { scrollToId } from "../../lib/scroll";


const HERO_IMG = `${process.env.PUBLIC_URL}/timo-presenting.webp`;

const scrollTo = scrollToId;

export const Hero = ({ t }) => {
  return (
    <section id="home" className="relative pt-32 md:pt-40 pb-16 md:pb-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <div className="lg:col-span-8">
            <motion.p
              initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.15, duration: 0.8 }}
              className="text-xs md:text-sm uppercase tracking-[0.24em] font-bold text-green mb-8"
              data-testid="hero-eyebrow"
            >
              {t.hero.eyebrow}
            </motion.p>

            <h1 className="font-display font-medium text-ink leading-[1.02] tracking-tight text-4xl sm:text-5xl md:text-6xl lg:text-7xl">
              {t.hero.lines.map((line, i) => (
                <span key={i} className="block">{line}</span>
              ))}
            </h1>

            <motion.p
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.95, duration: 0.9 }}
              className="mt-10 text-lg md:text-xl leading-relaxed text-ink-2 max-w-2xl"
              data-testid="hero-lead"
            >
              {t.hero.lead}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 1.1, duration: 0.9 }}
              className="mt-11 flex flex-col sm:flex-row items-start sm:items-center gap-4"
            >
              <button
                data-testid="hero-primary-cta"
                onClick={() => scrollTo("contact")}
                className="group inline-flex items-center gap-2 bg-green hover:bg-green-hover text-bone text-base font-medium px-7 py-4 transition-colors duration-300"
              >
                {t.hero.primary}
                <ArrowRight size={18} className="transition-transform duration-300 group-hover:translate-x-1" />
              </button>
              <button
                data-testid="hero-secondary-cta"
                onClick={() => scrollTo("approach")}
                className="group inline-flex items-center gap-2 text-base font-medium text-ink px-2 py-4"
              >
                <span className="link-underline pb-1">{t.hero.secondary}</span>
                <ArrowDownRight size={18} className="transition-transform duration-300 group-hover:translate-y-0.5" />
              </button>
            </motion.div>
          </div>

          <div className="lg:col-span-4 relative">
            <div className="relative aspect-[3/4] overflow-hidden bg-secondary">
              <motion.img
                src={HERO_IMG}
                alt="Timo Schewik moderiert einen Workshop"
                className="absolute inset-0 w-full h-full object-cover object-top"
                data-testid="hero-image"
              />
              <div className="absolute inset-0 ring-1 ring-inset ring-black/5" />
            </div>
          </div>
        </div>

        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 1.3, duration: 1 }}
          className="mt-16 md:mt-24 grid grid-cols-1 sm:grid-cols-3 border-t border-line"
          data-testid="hero-meta"
        >
          {t.hero.meta.map(([big, small], i) => (
            <div key={i} className={`py-6 md:py-8 ${i > 0 ? "sm:border-l border-line sm:pl-8" : ""}`}>
              <div className="font-display text-3xl md:text-4xl text-ink leading-none">{big}</div>
              <div className="mt-2 text-sm text-muted whitespace-pre-line">{small}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
